"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Panel", {
  enumerable: true,
  get: function () {
    return _Panel.Panel;
  }
});
Object.defineProperty(exports, "PanelBody", {
  enumerable: true,
  get: function () {
    return _Panel.PanelBody;
  }
});
Object.defineProperty(exports, "PanelFooter", {
  enumerable: true,
  get: function () {
    return _Panel.PanelFooter;
  }
});
Object.defineProperty(exports, "PanelHeader", {
  enumerable: true,
  get: function () {
    return _Panel.PanelHeader;
  }
});
var _Panel = require("./Panel");